module.exports = __webpack_public_path__ + "img/example_score.8410e1e7.png";